import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import { CustomResultOfListOfGetOutboxMessageTransactionsDto } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ScheduledMessageIdsStorageService } from 'src/app/core/services/scheduled-message-ids-storage.service';
import { AppFontSize } from 'src/app/core/types/app-font-size.type';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { GetEnumValuesDto } from '../../../../core/api/models/get-enum-values-dto';
import { GetOutboxMessageTransactionsDto } from '../../../../core/api/models/get-outbox-message-transactions-dto';
import { TypeTransactions } from '../../../../core/api/models/type-transactions';
import { OutBoxMessagesService } from '../../../../core/api/services';
import { OrganizationTransactionsService } from '../../../../core/api/services/organization-transactions.service';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';

@Component({
  selector: 'app-outbox-transactions',
  templateUrl: './outbox-transactions.component.html',
  standalone: false,
})
export class OutboxTransactionsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'organizationTransactions';
  scheduledMessageId;
  items: GetOutboxMessageTransactionsDto[];
  fontSize: AppFontSize = 'sm';

  //enums
  get TypeTransactions() {
    return TypeTransactions;
  }

  TypeTransactionsEnumValues: GetEnumValuesDto[] = [];
  TypeCreditChangesEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor(
    protected currentService: OrganizationTransactionsService,
    public outBoxMessagesService: OutBoxMessagesService,
    private scheduledMessageIdsStorageService: ScheduledMessageIdsStorageService,
    private tabsDynamicComponent: TabsDynamicComponent
  ) {
    super();
    this.scheduledMessageId =
      this.scheduledMessageIdsStorageService.scheduledMessageId;
  }

  ngOnInit() {
    try {
      // اگر کاربر با انتخاب گزینه در پرنت آمده بود آیدی پرنت رو به یوآرال اضافه میکنیم و اگر با یوآرال آمده بود آیدی پرنت رو از یوآرال میخونیم
      this.showParent = false;
      this.setParentQueryString();
      if (this.scheduledMessageId && !window.location.search.includes('key-')) {
        this.location.go(
          window.location.pathname +
            window.location.search +
            '?' +
            QueryStringTypesEnum.ScheduledMessage_key +
            '=' +
            this.scheduledMessageId
        );
      } else {
        let params = this.routingState.parseQueryString();
        for (const [key, value] of Object.entries(params)) {
          if (key == QueryStringTypesEnum.ScheduledMessage_key) {
            this.scheduledMessageId = +value;
          }
        }
      }

      this.getEnumsValues();
      this.getVocabs();
      this.configTableColumns();
      this.configPage();
      this.getData();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.tableConfig.hidePagination = true;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.tableConfig.showOperationColumn = false;
      this.pageConfig.title =
        'pages.organizationTransactions.outboxTransactionsTitle';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('TypeCreditChanges')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.TypeCreditChangesEnumValues = values));
    this.getEnumValuesApi('TypeTransactions')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.TypeTransactionsEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.amount,
        name: 'amount',
        type: 'number',
        needCurrency: true,
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}currentCredit`,
        name: 'currentCredit',
        type: 'number',
        needCurrency: true,
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}typeTransaction`,
        name: 'typeTransaction',
        type: 'enum',
        enumName: 'TypeTransactions',
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}typeCreditChange`,
        name: 'typeCreditChange',
        type: 'enum',
        enumName: 'TypeCreditChanges',
        noSorting: true,
      },
      {
        title: this.localizer.user,
        name: 'userName',
        noSorting: true,
      },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        noSorting: true,
      },
      {
        title: this.localizer.description,
        name: 'description',
        noSorting: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: false,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  getData() {
    this.pageConfig.loading = true;

    this.getOutboxMessageTransactionsApi()
      .pipe(
        tap((items) => {
          items?.data?.length > 0
            ? (this.pageConfig.isEmpty = false)
            : (this.pageConfig.isEmpty = true);
        }),
        takeUntil(this.onDestroy$),
        finalize(() => (this.pageConfig.loading = false)),
        catchError((err) => {
          this.closeThisTab();
          return of(err);
        })
      )
      .subscribe((items) => {
        this.items = items?.data;
      });
  }

  //#region Api
  getOutboxMessageTransactionsApi(): Observable<CustomResultOfListOfGetOutboxMessageTransactionsDto> {
    return this.outBoxMessagesService.outBoxMessagesGetOutboxMessageTransactions(
      { id: this.scheduledMessageId }
    );
  }

  //#endregion

  getPaginationApi(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  closeThisTab() {
    try {
      const TimeOut = setTimeout(() => {
        this.tabsDynamicComponent.manualCloseTab('outboxTransactions');
        this.unSubs();
        clearTimeout(TimeOut);
      }, 50);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }
}
